module.exports = __webpack_public_path__ + "media/public/img/chatbot-7531d470925c3d57abc41129e9617a90.png";